const WhyThisExists = () => {
  return (
    <section className="py-14 md:py-18 bg-section-alt">
      <div className="container-narrow">
        <div className="max-w-[840px] mx-auto text-center space-y-6">
          <h2 data-reveal className="text-2xl md:text-3xl font-semibold text-primary">
            How we build websites
          </h2>
          <div className="space-y-4 text-lg text-soft leading-relaxed">
            <p data-reveal style={{ transitionDelay: "100ms" }}>
              We build websites with a focus on clarity, structure, and ease of contact — not trends or gimmicks.
            </p>
            <p data-reveal style={{ transitionDelay: "200ms" }}>
              Some clients are adding a standalone site alongside a brokerage or directory page. Others are improving an existing real estate website. In both cases, the goal is the same: a clean, professional site that clearly explains what you do and makes it easy for the right people to reach out.
            </p>
            <p data-reveal style={{ transitionDelay: "300ms" }}>
              We simplify layouts, tighten messaging, and remove distractions so visitors quickly understand who you help and how to contact you.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyThisExists;
